// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3zLdc","notes":"Notes_notes__1Rdxy","note":"Notes_note__3bZij","markdown":"Notes_markdown__2ncE_"};